import { useState } from 'react';
import { siteApi } from '../tjenester/siteApi';

const emptyInquiry = {
  name: '',
  email: '',
  phone: '',
  message: '',
};

function InquiryForm({ propertyName = '', propertySlug = '' }) {
  const [form, setForm] = useState(emptyInquiry);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (!form.name.trim() || !form.message.trim()) {
      setErrorMessage('Fyll inn navn og melding.');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await siteApi.submitInquiry({
        ...form,
        propertyName,
        propertySlug,
      });
      setSuccessMessage(response.message || 'Takk! Vi har mottatt henvendelsen din.');
      setForm(emptyInquiry);
    } catch (error) {
      setErrorMessage(error.message || 'Klarte ikke sende henvendelsen. Prov igjen senere.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="grid gap-4" onSubmit={handleSubmit}>
      {propertyName ? (
        <p className="text-sm text-[#7c6b52]">
          Henvendelse om <span className="font-semibold text-[#163127]">{propertyName}</span>
        </p>
      ) : null}
      <label className="grid gap-2">
        <span className="text-sm font-semibold text-[#355046]">Navn</span>
        <input
          className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
          onChange={(event) => setForm((current) => ({ ...current, name: event.target.value }))}
          required
          type="text"
          value={form.name}
        />
      </label>
      <div className="grid gap-4 sm:grid-cols-2">
        <label className="grid gap-2">
          <span className="text-sm font-semibold text-[#355046]">E-post (valgfritt)</span>
          <input
            className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
            onChange={(event) => setForm((current) => ({ ...current, email: event.target.value }))}
            type="email"
            value={form.email}
          />
        </label>
        <label className="grid gap-2">
          <span className="text-sm font-semibold text-[#355046]">Telefon (valgfritt)</span>
          <input
            className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
            onChange={(event) => setForm((current) => ({ ...current, phone: event.target.value }))}
            type="tel"
            value={form.phone}
          />
        </label>
      </div>
      <label className="grid gap-2">
        <span className="text-sm font-semibold text-[#355046]">Melding</span>
        <textarea
          className="min-h-[120px] rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
          onChange={(event) => setForm((current) => ({ ...current, message: event.target.value }))}
          required
          value={form.message}
        />
      </label>
      {successMessage ? <p className="text-sm font-semibold text-[#1d4c3b]">{successMessage}</p> : null}
      {errorMessage ? <p className="text-sm font-semibold text-[#a23b3b]">{errorMessage}</p> : null}
      <button
        className="inline-flex min-h-12 w-fit items-center justify-center rounded-full bg-[#1d4c3b] px-6 font-semibold text-[#f9f5ee] disabled:opacity-60"
        disabled={isSubmitting}
        type="submit"
      >
        {isSubmitting ? 'Sender ...' : 'Send henvendelse'}
      </button>
    </form>
  );
}

export default InquiryForm;
